import { CountryCode } from '~/enums';
import { homePageByMarket, marketUsesOneQredApp } from '~/constants/markets';
import { Language } from '~/store/types/sharedTypes';

export const openQredHomePage = (market: CountryCode, language: Language) => {
  const url = homePageByMarket[market][language];
  window.open(
    url,
    market === CountryCode.NL ? 'qeldHome' : 'qredHome',
    'noopener'
  );
};

// Germany uses the new "OneQred" app, published separately from the legacy Qred app.
export const ONEQRED_APP_STORE_URL =
  'https://apps.apple.com/de/app/qred/id6788032620';
export const ONEQRED_GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.qred.oneqred';

const LEGACY_APP_STORE_URL = 'https://apps.apple.com/se/app/qred/id1528985194';
const LEGACY_GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.qred';

export const getAppStoreUrl = (
  market: CountryCode,
  language: Language
): string => {
  if (marketUsesOneQredApp(market)) {
    return ONEQRED_APP_STORE_URL;
  }
  switch (language) {
    case Language.Swedish:
      return LEGACY_APP_STORE_URL;
    case Language.Finnish:
      return `${LEGACY_APP_STORE_URL}?l=fi`;
    default:
      return `${LEGACY_APP_STORE_URL}?l=en`;
  }
};

export const getGooglePlayUrl = (market: CountryCode): string =>
  marketUsesOneQredApp(market)
    ? ONEQRED_GOOGLE_PLAY_URL
    : LEGACY_GOOGLE_PLAY_URL;

export const openAppStore = (market: CountryCode, language: Language) => {
  window.open(getAppStoreUrl(market, language), 'appStore', 'noopener');
};

export const openGooglePlay = (market: CountryCode) => {
  window.open(getGooglePlayUrl(market), 'googlePlay', 'noopener');
};
